module.exports = __webpack_public_path__ + "static/media/5_Katty_P@2x.acd2b50f.jpg";